import { useMemo } from 'react'
import { useAdmin, useNavigation } from '@vtex/raccoon-next'
import { APP_ROUTE } from '@/data/constants'
import { generateFullSiteURL } from '@/lib/transform'

const useEditorUrl = (newPath: string) => {
  const { account, workspace } = useAdmin()

  const link = useMemo(() => {
    const siteUrl = `${generateFullSiteURL(account, workspace)}`

    return `${siteUrl}/${APP_ROUTE}/product/${newPath}`
  }, [account, newPath, workspace])

  return link
}

const useNavigateToEditor = (newPath: string) => {
  const { navigate } = useNavigation()

  const navigateToEditor = () => navigate(`/product/${newPath}`)

  return navigateToEditor
}

export const useProductEditorURL = (productId: number) => {
  const productUrl = useEditorUrl(`${productId}`)

  return productUrl
}

export const useSkuEditorURL = (productId: number, skuId: number) => {
  const skuUrl = useEditorUrl(`${productId}/sku/${skuId}`)

  return skuUrl
}

export const useNavigateToProductEditor = (productId: number) => {
  const navigateToProductEditor = useNavigateToEditor(`${productId}`)

  return navigateToProductEditor
}

export const useNavigateToSkuEditor = (productId: number, skuId: number) => {
  const navigateToSkuEditor = useNavigateToEditor(`${productId}/sku/${skuId}`)

  return navigateToSkuEditor
}
